import { render, staticRenderFns } from "./SDKDetailView.vue?vue&type=template&id=3ab2d04e&scoped=true&"
import script from "./SDKDetailView.vue?vue&type=script&lang=js&"
export * from "./SDKDetailView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=3ab2d04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2d04e",
  null
  
)

export default component.exports